module.exports = __webpack_public_path__ + "img/e59e4a1.svg";